// declare process variable
declare const process: {
    env: {
        NODE_ENV: string,
    },
};

/**
 * Returns `true` when the code is running inside a test runner.
 *
 * Checks `process.env.NODE_ENV` against the set of known test environment
 * values (`'test'` and `'test:chrome:plugin'`). Use this to guard code paths
 * that should behave differently in tests — for example, disabling animations,
 * skipping analytics calls, or bypassing browser-only APIs.
 *
 * @returns `true` if the current environment is a test environment, `false` otherwise.
 *
 * @example
 * ```ts
 * if (!isTestEnvironment()) {
 *   initAnalytics();
 * }
 * ```
 */
export const isTestEnvironment = (): boolean =>
    ['test', 'test:chrome:plugin'].includes(
        process.env.NODE_ENV as string,
    );
